import { Type } from '@angular/core';

export type CustomScreenLoader = () => Promise<Type<unknown>>;

// Generated by `npm run customize -- <screen-id>`. Do not edit manually.
export const CUSTOM_SCREEN_LOADERS: Record<string, CustomScreenLoader> = {
  'spriced-home': () => import('./custom/spriced-home/home-screen.component').then(({ HomeScreenComponent }) => HomeScreenComponent),
  'approvals': () => import('./custom/approvals/approval-workflow-hub-screen.component').then(({ ApprovalWorkflowHubScreenComponent }) => ApprovalWorkflowHubScreenComponent),
  'approval-workflows': () => import('./custom/approval-workflows/approval-workflow-builder-screen.component').then(({ ApprovalWorkflowBuilderScreenComponent }) => ApprovalWorkflowBuilderScreenComponent),
  'domain-catalogs': () => import('./custom/domain-catalogs/domain-catalogs.component').then(({ DomainCatalogsComponent }) => DomainCatalogsComponent),
};
